export default {
      id: "create-contract-usage",
      viewBox: "0 0 59.122 65.951",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#create-contract",
      toString: function () {
        return this.url;
      }
    }